import { render, staticRenderFns } from "./ModalAddPartner.vue?vue&type=template&id=a65bd7c8&"
import script from "./ModalAddPartner.vue?vue&type=script&lang=js&"
export * from "./ModalAddPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports